import React from "react";
import { SectionLocked } from "features/AdminPanel/modules/SectionLocked/SectionLocked";
import { SectionUnlockingSwitch } from "features/AdminPanel/modules/SectionUnlockingSwitch/SectionUnlockingSwitch";
import { WhitelabelLockComponent } from "features/Account/modules/Whitelabel/modules/WhitelabelLock/modules/WhitelabelLockComponent/WhitelabelLockComponent";
import { useWhitelabelLock } from "features/Account/modules/Whitelabel/modules/WhitelabelLock/useWhitelabelLock";
import { useWhitelabel } from "features/Account/modules/Whitelabel/utils/useWhitelabel";
import { useCustomFooterToggle } from "./hooks/useCustomFooterToggle";

export const CustomFooterToggle = () => {
  const { isAccessible, handleWhitelabelPurchase, whiteLabelDetails } =
    useWhitelabel();
  const { showWhitelabelUnlockModal, toggleWhitelabelUnlockModal } =
    useWhitelabelLock();
  const { value, handleChange, processing } = useCustomFooterToggle();

  const isWhitelabelLocked = isAccessible !== true;

  return (
    <>
      <div className="tw-flex tw-items-center tw-gap-3">
        <SectionUnlockingSwitch
          value={value}
          onChange={() => handleChange(!value)}
          disabled={processing || isWhitelabelLocked}
        />
        {isWhitelabelLocked && (
          <div
            onClick={toggleWhitelabelUnlockModal}
            className="tw-cursor-pointer"
            title="Unlock with White-labelling"
          >
            <SectionLocked />
          </div>
        )}
      </div>
      {isWhitelabelLocked && (
        <WhitelabelLockComponent
          hideLabel
          hideIcon
          modalDescription={{
            heading: "Edit Custom Footer via White-labelling",
          }}
          isAccessible={isAccessible}
          handleWhitelabelPurchase={handleWhitelabelPurchase}
          whiteLabelDetails={whiteLabelDetails}
          showWhitelabelUnlockModal={showWhitelabelUnlockModal}
          toggleWhitelabelUnlockModal={toggleWhitelabelUnlockModal}
        />
      )}
    </>
  );
};
